export default {
  namespaced: true,
  state: {
    page: null,
  },
  actions: {
    getRules({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'page', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('pages/api/page', { url: 'rules' })
          .then((response) => {
            if (response && response.data && response.data.page) {
              commit('setField', { name: 'page', value: response.data.page });
              resolve(response.data);
            } else {
              reject(new Error('no response data'));
            }
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreRules({ commit }) {
      commit('setField', { name: 'page', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
